export default {
    data() {
        return {
            accessKey: '',
            businessTypeList: []
        }
    },
    mounted() {
        if (this.$route.query) {
            if (this.$route.query.title) {
                sessionStorage.setItem('botName', this.$route.query.title);
            }
        }
        this.accessKey = sessionStorage.getItem('accessKey');
        this.getBusinessType();
    },
    methods: {
        /**
         * 获取产品列表
         */
        async getBusinessType() {
            if (sessionStorage.getItem('skillGroups')) {
                this.businessTypeList = JSON.parse(sessionStorage.getItem('skillGroups'));
                return;
            }
            let res = await this.$http.get(`/skillGroup?accessKey=${this.accessKey}`);
            if(res.data && res.data.length) {
              this.businessTypeList = res.data;
            }
        },
        /**
         * 选择产品
         * @param { Object } item ==> 当前点击的产品信息
         */
        selectBusiness(item) {
            sessionStorage.setItem('business',item.id);
            let businessName = item.alias_name || item.name;
            sessionStorage.setItem('businessName', businessName);
            sessionStorage.setItem('businessType', item.type || 1);
            this.$router.push({
                name: 'webot',
                query: {
                    accessKey: this.accessKey
                }
            });
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/business/_bussiness.js